import React, { FC } from 'react';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import cn from 'classnames';
import styles from 'components/admin/orders/recurring-orders/individualRecurringOrder.module.scss';
import {
  TimelineItem as Item,
  RecurringOrderSettingsOrigin,
  TimelineActions,
} from 'api/admin/orders/getRecurringOrder';
import { ORIGIN_DISPLAY } from 'constants/recurringOrders/origins';

export const HistoryItem: FC<{
  item: Item;
}> = ({ item }) => {
  const isInstanceSkipped = !item.data.serviceOrderId;
  const isInitialInstance = item.origin === RecurringOrderSettingsOrigin.LIVE_LINK_ORDER_CREATION;
  const isRecurringOrderCreated = item.action === TimelineActions.RECURRING_ORDER_CREATED;
  const isMigrationItem =
    item.origin === RecurringOrderSettingsOrigin.INHERITED_FROM_RECURRING_SUBSCRIPTION;

  let actionDisplay = 'Recurring order created';

  if (isMigrationItem) {
    actionDisplay = 'Recurring order migrated from v.1';
  } else if (!isRecurringOrderCreated) {
    actionDisplay = 'Recurring order creation skipped';
  }

  return (
    <TimelineItem
      key={`${item.itemTimestamp} ${item.instanceWeek}`}
      className={styles.timeLineItem}
    >
      <TimelineOppositeContent color="textSecondary" className={cn(styles.timestamp)}>
        {item.itemTimestamp}
        <p className={styles.target}>
          Pickup week: <span>{item.instanceWeek}</span>
        </p>
      </TimelineOppositeContent>
      <TimelineSeparator>
        <TimelineDot />
        {!isInitialInstance && <TimelineConnector />}
      </TimelineSeparator>
      <TimelineContent className={styles.timelineItemContent}>
        <p
          className={cn(styles.title, {
            [styles.dangerText]: item.action === TimelineActions.INSTANCE_SKIP,
          })}
        >
          {actionDisplay}
        </p>

        <p className={cn(styles.orderDetails)}>
          Service order:{' '}
          {item.data.serviceOrderId ? (
            <a
              href={`/service-orders/${Number(item.data?.serviceOrderId)}`}
              target="_blank"
              rel="noreferrer"
            >
              {item.data.orderCode}
            </a>
          ) : (
            <span
              className={cn({
                [styles.dangerText]: item.data?.serviceOrderId === null,
              })}
            >
              Order creation skipped
            </span>
          )}
        </p>
        {item.teamMemberName && isInstanceSkipped && (
          <p className={styles.author}>
            Skipped by: <span>{item.teamMemberName}</span>
          </p>
        )}
        {item.teamMemberName && isInitialInstance && (
          <p className={styles.author}>
            Created by: <span>{item.teamMemberName}</span>
          </p>
        )}
        {item.origin && isInstanceSkipped && (
          <p className={styles.author}>
            Skip origin: <span>{ORIGIN_DISPLAY[item.origin]}</span>
          </p>
        )}
        {isMigrationItem && (
          <p className={styles.author}>
            Origin: <span>Recurring order migration in Internal Manager</span>
          </p>
        )}
      </TimelineContent>
    </TimelineItem>
  );
};
